/*=============================
=       Gallery Load More     =
=============================*/

var loadMore = document.getElementById('load-more-gallery'),
	galleryOther = document.querySelector('#gallery-others .gallery-container'),
	currentPage = 2;

if(!galleryOther.querySelectorAll('.before_after_images').length)
	document.getElementById('gallery-others').style.paddingTop = 0;

if(loadMore) {
	loadMore.addEventListener('click', function() {
		loadMore.setAttribute('disabled', true);

		galleryOther.style.minHeight = galleryOther.offsetHeight+'px';

		axios.post('/gallery-load', {page: ++currentPage})
		.then(function(r) {
			if(r.data.cards) {
				galleryOther.innerHTML+= r.data.cards;
				Velocity(galleryOther, 'slideDown', {duration: 500, display: 'flex'});
				loadMore.removeAttribute('disabled');

				if(r.data.last)
					loadMore.style.display = 'none';
			}
		})
		.catch(function (e) {
			console.log(e);
		});
	});
}